<template>
  <base-container ref="container" :isLoading="loading">
    <a-card style="height: 100%;overflow: auto;">
      <div class="templates">
        <div v-for="(template, key) in templates"  :key="key">
          <div class="item-box" @click="show(template)">
            <!-- <a-popover>
              <template #content>
                <img style="cursor: pointer;" src="~@/views/print/assets/logo.png" @click="show(template)" />
              </template>
            </a-popover> -->
            <img class="preview" style="padding: 35px;" src="~@/views/print/assets/logo.png" />

            <div class="name pd">{{ template.name }}</div>

            <div class="desc pd">{{ template.remark }}</div>
            <div class="author pd" @click.stop="removeTemp(template.id)">删除
              <!-- <a :href="template.link" target="_blank">{{ template.author }}</a> -->
            </div>
          </div>
        </div>
      </div>
      <template-preview  @selectTemp="selectTemp" ref="preview" />
    </a-card>
  </base-container>
</template>

<script>
//import templates from './files'
import templatePreview from './preview'
import printData from "../design/print-data";
import { list, remove } from "@/api/print/print";
export default {
  name: "templates",
  components: { templatePreview },
  data() {
    return {
      loading: false,
      templates: [],
    }
  },
  created() {
    this.selectTemp()
  },
  mounted() {
  },
  methods: {
    selectTemp() {
      this.loading = true
      list().then((res) => {
        this.templates = res.data.data
        this.loading = false
      })
    },
    removeTemp(id) {

      this.$refs.container.confirm({ msg: "确认删除？" }).then(() => {
        this.loading = true
        remove(id).then(() => {
          this.selectTemp()
          this.loading = false
          this.$message({
            type: "success",
            message: "删除成功！",
          });
        });
      });
    },
    show(template) {
      this.$refs.preview.show(template)
    }
  }
}
</script>

<style scoped lang="less">
.templates {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

.item-box {
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 10px #ccc;
  border-radius: 10px;
  margin: 0 10px 10px 0;

  img {
    object-fit: cover;
  }

  .preview {
    height: 200px;
    width: 200px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .pd {
    padding: 4px 6px;
  }

  .name {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  .desc {
    font-size: 12px;
    color: #999;
  }

  .author {
    text-align: center;
    color: red;
  }
}

.item-box:hover {
  box-shadow: 0 0 10px #999;
  cursor: pointer;
}
</style>
